import { axios } from '@/utils/request'

const api = {
  master: '/master/master',
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
}

export function addMaster (parameter) {
  return axios({
    url: api.master + '/addMaster',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 省市区下拉
export function getSelectAllProvince (parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName  (parameter) {
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectAreaName (parameter) {
  return axios({
    url: api.area + '/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// export const remindMap = {
//   '0': '否',
//   '1': '是'
// }
//
// export const fieldType = {
//   '0': '单选框',
//   '1': '输入框',
//   '2': '单选+输入'
// }

export const channelExport = api.channel + '/export'
